import { themed } from '@indeed/ifl-css';

/**
 * PopoverBody
 *
 * @deprecated The `Popover` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 **/
const PopoverBody = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: [],
  target: "ec7ufkn0"
} : {
  styleProps: [],
  target: "ec7ufkn0",
  label: "PopoverBody"
})(() => ({
  boxSizing: "border-box",
  marginBlockStart: 0,
  marginBlockEnd: 0,
  marginInlineStart: 0,
  marginInlineEnd: 0,
  minBlockSize: 0,
  variant: "text.level3"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBvcG92ZXJCb2R5LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRMkIiLCJmaWxlIjoiUG9wb3ZlckJvZHkudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdGhlbWVkIH0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuXG4vKipcbiAqIFBvcG92ZXJCb2R5XG4gKlxuICogQGRlcHJlY2F0ZWQgVGhlIGBQb3BvdmVyYCBjb21wb25lbnQgd2lsbCBiZSByZW1vdmVkIGluIElGTCA3LlxuICogU2VlIHRoZSBJRkwgNyBwcmVwYXJhdGlvbiBndWlkZSBmb3IgbW9yZSBpbmZvcm1hdGlvbjogaHR0cHM6Ly9saW5rLmluZGVlZC50ZWNoL2lmbC03LXByZXAtZ3VpZGVcbiAqKi9cbmV4cG9ydCBjb25zdCBQb3BvdmVyQm9keSA9IHRoZW1lZChcImRpdlwiLCB7IHN0eWxlUHJvcHM6IFtdIH0pKCgpID0+ICh7XG4gIGJveFNpemluZzogXCJib3JkZXItYm94XCIsXG4gIG1hcmdpbkJsb2NrU3RhcnQ6IDAsXG4gIG1hcmdpbkJsb2NrRW5kOiAwLFxuICBtYXJnaW5JbmxpbmVTdGFydDogMCxcbiAgbWFyZ2luSW5saW5lRW5kOiAwLFxuICBtaW5CbG9ja1NpemU6IDAsXG4gIHZhcmlhbnQ6IFwidGV4dC5sZXZlbDNcIlxufSkpO1xuXG5Qb3BvdmVyQm9keS5kaXNwbGF5TmFtZSA9IFwiUG9wb3ZlckJvZHlcIjtcbiJdfQ== */");
PopoverBody.displayName = "PopoverBody";

export { PopoverBody };
